import React, { useMemo, useState } from 'react';
import UserService from '../../services/UserService';
import validator from 'validator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom'
import './RegistrationCard.css';

const RegistrationCard = ({
    email, 
  logoSrc,
  logoAlt = 'Phius Logo',
  onRegSuccess
}) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [generalError, setGeneralError] = useState('');

  const isFormValid = useMemo(() => {
    return password !== '' && confirmPassword !== '';
  },[confirmPassword, password])

  const handleSubmit = ev => {
    ev.preventDefault()
    setPasswordError('');
    setConfirmPasswordError('');
    setGeneralError('');

    let valid = true;

    const errors = []
    // Email validation (even though it's disabled, we still enforce format)
    if (!validator.isEmail(email)) {
      setGeneralError('The email has not been found. Please contact Phius support for assistance');
      valid = false;
    }
    // Password length
    if (password.length < 6) {
      setPasswordError('Passwords must be longer than 5 characters');
      valid = false;
    }
    // Match check
    if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords must match');
      valid = false;
    }

    if (!valid) return;

    // Submit to backend
    UserService.postUser({ email, password })
    .then(res => {
      onRegSuccess()
    })
    .catch(resErr => {
      const msg = resErr || 'No matching CRM Contact'
      setGeneralError(msg)
    })
  }

  return (
    <div className="registration-card">
      <div className="card-header">
        <img src={logoSrc} alt={logoAlt} className="card-logo" />
      </div>


      <h2 className="card-title">
        Create Account
      </h2>

      <form onSubmit={handleSubmit} className="card-form">
        {generalError && (
          <div role="alert">
            <p className="form-error">{generalError}</p>
          </div>
        )}
        <div className='form-group input-wrapper'>
          <label
            htmlFor="password"
            className="form-label"
          >
            Create Password
          </label>
          <input
            id="password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            className="form-input"
          />
          <button type='button' className='password-toggle-btn' onClick={() => setShowPassword(v => !v)}>
            {showPassword ? <FontAwesomeIcon icon={"eye"} color='#6B7280' /> : <FontAwesomeIcon icon={"eye-slash"} color='#6B7280' />}
          </button>
        </div>
        {passwordError && (
          <p className="input-error">{passwordError}</p>
        )}

        <div className='form-group input-wrapper'>
          <label
            htmlFor="confirmPassword"
            className="form-label"
          >
            Re‑enter Password
          </label>
          <input
            id="confirmPassword"
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re‑enter your password"
            className="form-input"
          />
          <button type='button' className='password-toggle-btn' onClick={() => setShowConfirmPassword(v => !v)}>
            {showConfirmPassword ? <FontAwesomeIcon icon={"eye"} color='#6B7280' /> : <FontAwesomeIcon icon={"eye-slash"} color='#6B7280' />}
          </button>
        </div>
        {confirmPasswordError && (
          <p className="input-error">{confirmPasswordError}</p>
        )}

        <div className='card-footer'>
          <p className="account-message">Already have an account? <Link to="/" className="login-link">Go to Login</Link></p>
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={!isFormValid}
        >
          Create Account
        </button>
      </form>
    </div>
  );
};

export default RegistrationCard;
